<!--
 * @FileDescription: 账期管理
 * @Author: 陈文景
 * @Date: 2022-12-29 14:10:22
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <div>
    <Web v-if="isPC" />

    <Mobile v-else />
  </div>
</template>

<script>
import Web from './web/index.vue'
import Mobile from './mobile/index.vue'

export default {
  components: {
    Web,
    Mobile
  }
}
</script>
